if (!customElements.get("wdn-dropdown")) {
  class WDNDropdown extends HTMLElement {
    constructor() {
      super();
    }

    configureAttributes() {
      this.nameSpace = this.getAttribute("data-name") || "dropdown";

      this.selectors = {
        trigger: "[" + this.nameSpace + "-trigger]",
        container: "[" + this.nameSpace + "-container]",
        content: "[" + this.nameSpace + "-content]",
      };

      this.attributeList = {
        group: "group",
        active: this.nameSpace + "-active",
        resetHeight: "data-reset-height",
        animation: this.nameSpace + "-animate",
      };
    }

    buildConstructor() {
      this.configureAttributes();
      this.trigger = this.querySelector(this.selectors.trigger);
      this.container = this.querySelector(this.selectors.container);
      this.content = this.querySelector(this.selectors.content);
      this.group = this.getAttribute(this.attributeList.group);
      this.isActive = this.getAttribute(this.attributeList.active) === "";
      this.resetHeight = this.getAttribute(this.attributeList.resetHeight) === "";
      this.animation = parseInt(this.getAttribute(this.attributeList.animation)) || 0;
      this.autoInit = !(this.getAttribute("data-autoinit") === "false");
    }

    setState(newState) {
      this.isActive = newState;
    }

    setContainerHeight(newHeight) {
      var value = newHeight;
      if (typeof newHeight === "number") {
        value = newHeight + "px";
      }
      this.container.style.height = value;
    }

    shrinkContainer() {
      this.setContainerHeight(this.initialHeight);
    }

    expandContainer() {
      var contentHeight = this.content.offsetHeight;
      this.setContainerHeight(contentHeight);
    }

    setInactive() {
      this.expandContainer();
      setTimeout(
        function () {
          this.setState(false);
          this.removeAttribute(this.attributeList.active);
          this.shrinkContainer();

          // this will help when extending the component
          if (typeof this.onClose === "function") {
            this.onClose();
          }
        }.bind(this),
        50
      );
    }

    setActive() {
      this.collapseGroupContainers();
      this.setState(true);
      this.setAttribute(this.attributeList.active, "");
      this.expandContainer();

      // this will help when extending the component
      if (typeof this.onOpen === "function") {
        this.onOpen();
      }
    }

    fireGroupEvent() {
      var customEvent = new CustomEvent("dropdown:group:collapse", {
        detail: { initiator: this, group: this.group },
      });
      document.body.dispatchEvent(customEvent);
    }

    collapseGroupContainers() {
      if (this.group) {
        this.fireGroupEvent();
      }
    }

    beforeInactive() {
      this.expandContainer();
    }

    afterActive() {
      if (!this.animation) return;
      setTimeout(
        function () {
          this.setContainerHeight("auto");
        }.bind(this),
        this.animation
      );
    }

    onTriggerClick() {
      if (this.isActive) {
        this.beforeInactive();
        this.setInactive();
      } else {
        this.setActive();
        this.afterActive();
      }

      if (typeof this.onClick === "function") {
        this.onClick();
      }
    }

    onWindowResize() {
      if (this.isActive) {
        this.expandContainer();
      }
    }

    onGroupCollapse(e) {
      if (e.detail.initiator === this) return;
      if (this.group === e.detail.group && this.isActive) {
        this.setInactive();
      }
    }

    setInitialState() {
      if (this.isActive) {
        this.expandContainer();
      }
    }

    storeInitialHeight() {
      this.initialHeight = parseInt(this.container.style.height) || 0;
    }

    bind() {
      // Bind callbacks
      this.onTriggerClickBound = this.onTriggerClick.bind(this);
      this.onGroupCollapseBound = this.onGroupCollapse.bind(this);
      this.onWindowResizeBound = this.onWindowResize.bind(this);

      // Listeners
      this.trigger.addEventListener("click", this.onTriggerClickBound);
      document.body.addEventListener("dropdown:group:collapse", this.onGroupCollapseBound);
      window.addEventListener("window:resize", this.onWindowResizeBound);
    }

    init() {
      this.storeInitialHeight();
      this.setInitialState();
      this.bind();
    }

    disconnectedCallback() {
      // Listeners
      this.trigger.removeEventListener("click", this.onTriggerClickBound);
      document.body.removeEventListener("dropdown:group:collapse", this.onGroupCollapseBound);
      window.removeEventListener("window:resize", this.onWindowResizeBound);
    }

    // Code starts here
    connectedCallback() {
      this.buildConstructor();
      if (!this.autoInit) return;
      this.init();
    }
  }
  customElements.define("wdn-dropdown", WDNDropdown);
}
